<template>
  <div id="app" :class="{app: !$tkUa.isIos }"  class="has-notch">
    <router-view></router-view>
    <tk-global :components="components"></tk-global>
    <!--隐私协议弹框页面-->
    <div v-if="agreementShow"
         id="privacy"
         class="privacy"
    >
      <van-overlay :lock-scroll="false" :show="agreementShow" @click="show = false">
        <div class="wrapper" @click.stop>
          <tk-flex
            column
            center
            class="privacy-box"
          >
            <div class="privacy-title m-t-15">个人信息保护指引</div>
            <div class="p-15">
              <tk-scroller class="scroller-wrap"
                           :direction="'y'"
                           style="height:300px;"
              >
                <div v-html="privacyNotice" style="width: 270px" class="p-x-15 font-14"></div>
              </tk-scroller>
              <div class="privacy-bottom m-t-15 m-x-15 font-14">
                请认真阅读<i
                class="privacy-bottom-color"
                @click="privacyShow = true"
              >《 隐私政策 》</i>和<i
                class="privacy-bottom-color"
                @click="userShow = true"
              >《 用户声明 》</i>全部条款，您同意并接受全部条款后方可使用我们的服务。
              </div>
            </div>
            <div class="privacy-btn">
              <tkui-button class="border small btn-button btn-border" @click="refuseUse">不同意</tkui-button>
              <tkui-button class="primary border small btn-button" @click="userRead">同意并继续</tkui-button>
            </div>
          </tk-flex>
        </div>
      </van-overlay>
    </div>
    <!--退出提示-->
    <tkui-dialog class="quit-app" :show.sync="quitStatus" center>
      <div class="font-14">十分抱歉，若您不同意《威选商城隐私政策》和权限申请，我们将无法为您提供服务。</div>
      <template slot="action">
        <button class="tkui-dialog-button btn-button" @click="closeApp">关闭应用</button>
        <button class="tkui-dialog-button btn-button primary" @click="togglePrivacy">我再想想</button>
      </template>
    </tkui-dialog>
    <!--隐私协议详情页面-->
    <div class="privacy privacy-detail" v-if="privacyShow">
      <tk-container>
        <!--头部-->
        <tkui-header center slot="header">
          <div slot="left-menu" @click="privacyShow = false">
            <tkui-button class="icon">
              <tk-icon size="16">return</tk-icon>
            </tkui-button>
          </div>
          隐私政策
        </tkui-header>
        <!--协议内容-->
        <div class="privacy-detail-box" v-if="privacyNotice" v-html="privacyNotice"></div>
      </tk-container>
    </div>
    <!--用户协议详情展示-->
    <div class="privacy privacy-detail" v-if="userShow">
      <tk-container>
        <!--头部-->
        <tkui-header center slot="header">
          <div slot="left-menu" @click="userShow = false">
            <tkui-button class="icon">
              <tk-icon size="16">return</tk-icon>
            </tkui-button>
          </div>
          用户声明
        </tkui-header>
        <!--协议内容-->
        <div class="privacy-detail-box" v-if="userNotice" v-html="userNotice"></div>
      </tk-container>
    </div>
    <!--广告页面-->
    <tk-cover :show.sync="adMapCover" :hideOnBack="hideOnBack" :through="through" color="#000">
      <van-image
        lazy-load
        fit="cover"
        style="position: relative;height: 100%;"
        width="100%"
        :src="adMapSrc">
        <template v-slot:loading>
          <van-loading type="spinner" vertical size="30">加载中</van-loading>
        </template>
      </van-image>
      <tk-flex
        middle
        center
        class="ad-map-image"
         :style="{ top: statusBarHeight + 10 + 'px !important' }"
        @click.native="skipAdMap"
      >
        <div class="font-13">{{ timeMsc }}</div>
        <div class="ad-map-skip">跳过广告</div>
      </tk-flex>
    </tk-cover>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Overlay, Image as VanImage, Loading } from 'vant'
let timer = null
export default {
  name: 'app',
  components: {
    [Overlay.name]: Overlay,
    [VanImage.name]: VanImage,
    [Loading.name]: Loading
  },
  data () {
    return {
      adMapCover: false, // 广告页面是否需要显示
      agreementShow: false, // 协议弹框
      quitStatus: false, // 退出提示弹框
      privacyShow: false, // 隐私协议详情展示
      userShow: false, // 用户协议详情展示
      hideOnBack: false, //  手机物理按键不能关闭
      through: true, // 不可穿透
      userNotice: null, // 用户协议详情
      privacyNotice: null, // 隐私协议详情
      timeMsc: 5,
      components: [
        {
          name: 'toast',
          component: 'tk-toast'
        }
      ]
    }
  },
  computed: {
    ...mapState(['statusBarHeight']),
    adMapSrc () {
      return this.$store.state.adMapImage
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.agreementShow) {
      return
    }
    next(true)
  },
  beforeMount () {
    if (process.env.VUE_APP_ENV === 'app') {
      // 判断是否展示隐私协议
      if (!this.$store.state.isRead) {
        this.agreementShow = true
        this.getAppAgreement()
      } else {
        this.enterApp()
      }
    }
  },
  mounted () {
    this.setStatusBar('dark')
    this.getInit()
  },
  methods: {
    async getInit () {
      if (!this.$tkUa.isPlus) return this.$store.commit('setStatusBarHeight', 20)
      await this.$tkHelper.sleep(80)
      let statusBarHeight = window.plus.navigator.getStatusbarHeight()
      this.$store.commit('setStatusBarHeight', statusBarHeight || 20)
      if (!statusBarHeight) {
        await this.getInit()
      }
    },
    /**
    * 获取隐私协议
    * @date: 2020/3/12
    */
    async getAppAgreement () {
      let privacyPolicy = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/privacyPolicy').catch(e => {
        return { data: null }
      })
      let userAgreement = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/userAgreement').catch(e => {
        return { data: null }
      })
      if (privacyPolicy.data) { this.privacyNotice = privacyPolicy.data } else { this.privacyNotice = null }
      if (userAgreement.data) { this.userNotice = userAgreement.data } else { this.userNotice = null }
    },
    /**
    * 到关闭应用弹框
    * @date: 2020/12/8
    */
    refuseUse () {
      this.agreementShow = false
      this.quitStatus = true
    },
    /**
    * 关闭应用
    * @date: 2020/12/8
    */
    closeApp () {
      if (!this.$tkUa.isPlus) {
        return this.$tkGlobal.toast.add('该设备不是mobile')
      }
      if (this.$tkUa.isIos) {
        let plus = window.plus
        // return this.$tkGlobal.toast.add('请按设备提示退出')
        return plus.ios.import('UIApplication').sharedApplication().performSelector('exit')
      }
      setTimeout(() => { window.plus.runtime.quit() }, 20)
    },
    /**
    * 切换到协议弹框
    * @date: 2020/12/8
    */
    togglePrivacy () {
      this.quitStatus = false
      this.agreementShow = true
    },
    /**
    * 用于已阅读按钮
    * @date: 2020/3/12
    */
    userRead () {
      this.agreementShow = false
      this.enterApp()
      this.$store.commit('setIsRead', true)
    },
    /**
    * 同意隐私协议后可访问
    * @date: 2020/3/12
    */
    enterApp () {
      this.adMapCover = true
      timer = setInterval(() => {
        if (this.timeMsc > 0) {
          this.timeMsc--
        } else {
          clearInterval(timer)
          if (process.env.VUE_APP_ENV === 'app') {
            this.adMapCover = false
            this.setStatusBar(!!this.$store.state.user && !!this.$store.state.sessionToken ? 'light' : 'dark')
          } else {
            this.adMapCover = false
          }
        }
      }, 1000)
    },
    // 跳过广告页面
    skipAdMap () {
      clearInterval(timer)
      this.timeMsc = 0
      this.adMapCover = false
      this.setStatusBar(!!this.$store.state.user && !!this.$store.state.sessionToken ? 'light' : 'dark')
    }
  }
}
</script>
<style lang="scss">
  /*去掉输入框line-hight*/
  .app .tkui-input-container .tkui-input-body-warp .tkui-input-body .tkui-input {
    line-height: 0 !important;
  }
</style>
<style lang="scss" scoped>
  .has-notch {
    padding-bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  /*隐私协议样式*/
  .privacy {
    background: #fff;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99998;
    height: 100%;
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .privacy-box {
      background: #fff;
      border-radius: 5px;
      width: 282px;
      .privacy-title {
        font-size: 18px;
        font-weight: 700;
      }
      .privacy-bottom {
        .privacy-bottom-color {
          color: #D84342;
        }
      }
      .privacy-btn {
        width: 100%;
        font-weight: 600;
        font-size: 18px;
        height: 38px;
        display: flex;
        overflow: hidden;
        border-top: 1px solid #f5f5f5;
        text-align: center;
        color: #D84342;
        ::v-deep {
           .tkui-button.primary.border:hover {
             background-color: #ffffff !important;
             border-top-right-radius: 0 !important;
             border-bottom-right-radius: 5px !important;
          }
        }
        .primary {
          /*background: #D51613;*/
          color: #D51613;
          border-left: 1px solid #f5f5f5;
          overflow: hidden;
          border-right: none;
          border-top: none;
          border-bottom: none;
          // border-radius: 0 5px 0 5px !important;
        }
        .btn-button {
          width: 100%;
          height: 38px !important;
          margin: 0;
          border-bottom-right-radius: 5px;
        }
        .btn-border {
          border: none;
          color: #6E6E6E;
          border-radius: 0 0 0 5px !important;
        }
      }
    }
  }
  /*退出弹框*/
  .quit-app {
    ::v-deep {
      .tkui-dialog {
        border-radius: 5px !important;
      }
      .tkui-dialog .tkui-dialog-body {
        padding: 10px 10px 5px 10px !important;
      }
      .tkui-dialog-button {
        color: #6E6E6E;
        font-weight: 700;
        height: 38px !important;
      }
      .primary {
        color: #D51613 !important;
      }
    }
  }
  .privacy-detail {
    z-index: 99999;
    background-color: #f5f5f5 !important;
    .privacy-detail-header {
      width: 100%;
      height: 55px;
      background-color: #fff;
      font-size: 16px;
      line-height: 55px;
    }
    .privacy-detail-box {
      background: #fff;
      padding: 15px;
    }
  }
  /*广告图样式*/
  .ad-map-loading {
    /*background-position: center center;*/
    background-repeat:  no-repeat;
    background-size: 100% auto;
    min-height: 100%;
    width: 100%;
  }
  .ad-map-image {
    position: absolute;
    display: flex;
    border-radius: 15px;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    min-width: 78px;
    height: 25px;
    top: 0;
    right: 15px;
    color: #F41915;
    line-height: 1;
    .ad-map-skip {
      display: inline-block;
      padding-left: 4px;
      font-size: 12px;
      color: #fff;
    }
  }
</style>
